import { ethers } from 'ethers';

export const CONTRACT_ADDRESS = '0x4347d78beF5136f17b73f71e057Fb9Eb3A9fdB6a';
export const TOKEN_ADDRESS = '0xCdCae0f44126773cDb2c2049aaDf35dE8c1d6d51';
export const ADMIN = '0x0589b06C1a61ECc64844187DAe64B8A7Aa463Ca5';
export const HELPER = '0x8fFfD79B4a56dCB9fa1416b2C75bAC3776176308';
export const ADMINS = [
  '0xe8666427D06d7b0510A8d4a2dA76bCd55Cb64016',
  '0x0589b06C1a61ECc64844187DAe64B8A7Aa463Ca5',
  '0x8fFfD79B4a56dCB9fa1416b2C75bAC3776176308',
];

/**
 * Кто может подписывать изменения данных панели — тот же список, что в
 * `ADMINS` бэка. Здесь — только чтобы предупредить заранее: решает бэк.
 */
export const SIGNING_ADMINS = [
  '0xe8666427D06d7b0510A8d4a2dA76bCd55Cb64016',
  '0x0589b06C1a61ECc64844187DAe64B8A7Aa463Ca5',
];

/**
 * Проект Reown для WalletConnect. Не секрет — он всё равно уходит в бандл;
 * чужой домен Reown отвергнет по списку разрешённых в настройках проекта.
 */
export const WALLETCONNECT_PROJECT_ID = '1218db21f116882e7ad413e44833d6af';

export const EXPLORER_TX = 'https://bscscan.com/tx/';
export const EXPLORER_ADDRESS = 'https://bscscan.com/address/';

export const COINGECKO_API_URL =
  'https://api.coingecko.com/api/v3/simple/price?ids=binancecoin&vs_currencies=usd';

export const BACK_API_URL = process.env.REACT_APP_API_URL;

// RPC ходит через бэк, чтобы ключ ноды не попадал в бандл
export const PROVIDER = new ethers.JsonRpcProvider(`${BACK_API_URL}/rpc`, 56, {
  staticNetwork: true,
});

export const CHAIN_ID = '0x38';
export const CHAIN_PARAMS = [
  {
    chainId: CHAIN_ID,
    chainName: 'Binance Smart Chain',
    rpcUrls: ['https://bsc-dataseed.binance.org/'],
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18,
    },
    blockExplorerUrls: ['https://bscscan.com/'],
  },
];

export const shortAddress = (address: string | null | undefined): string => {
  return address ? `${address.slice(0, 6)}...${address.slice(-5)}` : '';
};
